package ch.wsl.typings.gridstack.distTypesMod

import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

@js.native
trait GridStackWidget
  extends StObject
     with GridStackPosition {
  
  /** if true then x, y parameters will be ignored and widget will be places on the first available position (default?: false) */
  var autoPosition: js.UndefOr[Boolean] = js.native
  
  /** html to append inside as content */
  var content: js.UndefOr[String] = js.native
  
  /** value for `gs-id` stored on the widget (default?: undefined) */
  var id: js.UndefOr[String] = js.native
  
  /** prevents being moved by others during their (default?: undefined = un-constrained) */
  var locked: js.UndefOr[Boolean] = js.native
  
  /** maximum height allowed during resize/creation (default?: undefined = un-constrained) */
  var maxH: js.UndefOr[Double] = js.native
  
  /** maximum width allowed during resize/creation (default?: undefined = un-constrained) */
  var maxW: js.UndefOr[Double] = js.native
  
  /** minimum height allowed during resize/creation (default?: undefined = un-constrained) */
  var minH: js.UndefOr[Double] = js.native
  
  /** minimum width allowed during resize/creation (default?: undefined = un-constrained) */
  var minW: js.UndefOr[Double] = js.native
  
  /** prevents moving (default?: undefined = un-constrained) */
  var noMove: js.UndefOr[Boolean] = js.native
  
  /** prevent resizing (default?: undefined = un-constrained) */
  var noResize: js.UndefOr[Boolean] = js.native
  
  /** optional nested grid options and list of children, which then turns into actual instance at runtime to get options from */
  var subGridOpts: js.UndefOr[GridStackOptions] = js.native
}
object GridStackWidget {
  
  @scala.inline
  def apply(): GridStackWidget = {
    val __obj = js.Dynamic.literal()
    __obj.asInstanceOf[GridStackWidget]
  }
  
  @scala.inline
  implicit class MutableBuilder[Self <: GridStackWidget] (val x: Self) extends AnyVal {
    
    @scala.inline
    def setAutoPosition(value: Boolean): Self = StObject.set(x, "autoPosition", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAutoPositionUndefined: Self = StObject.set(x, "autoPosition", js.undefined)
    
    @scala.inline
    def setContent(value: String): Self = StObject.set(x, "content", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setContentUndefined: Self = StObject.set(x, "content", js.undefined)
    
    @scala.inline
    def setId(value: String): Self = StObject.set(x, "id", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setIdUndefined: Self = StObject.set(x, "id", js.undefined)
    
    @scala.inline
    def setLocked(value: Boolean): Self = StObject.set(x, "locked", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setLockedUndefined: Self = StObject.set(x, "locked", js.undefined)
    
    @scala.inline
    def setMaxH(value: Double): Self = StObject.set(x, "maxH", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMaxHUndefined: Self = StObject.set(x, "maxH", js.undefined)
    
    @scala.inline
    def setMaxW(value: Double): Self = StObject.set(x, "maxW", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMaxWUndefined: Self = StObject.set(x, "maxW", js.undefined)
    
    @scala.inline
    def setMinH(value: Double): Self = StObject.set(x, "minH", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMinHUndefined: Self = StObject.set(x, "minH", js.undefined)
    
    @scala.inline
    def setMinW(value: Double): Self = StObject.set(x, "minW", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMinWUndefined: Self = StObject.set(x, "minW", js.undefined)
    
    @scala.inline
    def setNoMove(value: Boolean): Self = StObject.set(x, "noMove", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setNoMoveUndefined: Self = StObject.set(x, "noMove", js.undefined)
    
    @scala.inline
    def setNoResize(value: Boolean): Self = StObject.set(x, "noResize", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setNoResizeUndefined: Self = StObject.set(x, "noResize", js.undefined)
    
    @scala.inline
    def setSubGridOpts(value: GridStackOptions): Self = StObject.set(x, "subGridOpts", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSubGridOptsUndefined: Self = StObject.set(x, "subGridOpts", js.undefined)
  }
}
